import { FC } from 'react';
import InputRange, { InputRangeProps } from 'react-input-range';
import 'react-input-range/lib/css/index.css';

const OmlInputRange: FC<InputRangeProps> = ({ ...rest }) => {
  return <InputRange {...rest} />;
};

export { OmlInputRange };
